export default {
  name: 'final',
  data: function() {
    return {

    }
  },
  props: ['landingText', 'next'],
  methods: {
    goToSuccess: function() {
      let id = this.$route.params.id
      this.$router.push({
        name: 'success',
        params: {
          id
        }
      })
    }
  },
  beforeMount: function() {

  }
}


// WEBPACK FOOTER //
// ./src/components/test/subComponents/final/final.js